export default "__VITE_ASSET__594e00be__"